import { styled } from "styled-components";

export const Container = styled.div`
  position: relative;
  width: auto;
  height: 100%;
  min-height: 300px;
  flex-wrap: wrap;
  flex-direction: column;
  padding: 10px;
  margin: 10px;
  display: flex;
`;

export const CropContainer = styled.div`
  position: absolute;
  inset: 0;
`;
